export function formatReadDepth(value: any) {
    if (value === undefined || value === null || isNaN(value)) {
        return;
    }

	value = Math.round(value);

	return value + '%';
}

export default formatReadDepth;
